/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { UseContentSource_DisplayFragmentDoc } from '../../__generated__/useContentSource.graphql';
export type BulkUpdateContentSource_ContentSource_AppContentSource_Fragment = { __typename: 'AppContentSource', label?: string | null, applicationId: string };

export type BulkUpdateContentSource_ContentSource_BookmarkContentSource_Fragment = { __typename: 'BookmarkContentSource', index: number };

export type BulkUpdateContentSource_ContentSource_InputContentSource_Fragment = { __typename: 'InputContentSource', source: string };

export type BulkUpdateContentSource_ContentSource_PlaylistContentSource_Fragment = { __typename: 'PlaylistContentSource', playlistId: string };

export type BulkUpdateContentSource_ContentSourceFragment = BulkUpdateContentSource_ContentSource_AppContentSource_Fragment | BulkUpdateContentSource_ContentSource_BookmarkContentSource_Fragment | BulkUpdateContentSource_ContentSource_InputContentSource_Fragment | BulkUpdateContentSource_ContentSource_PlaylistContentSource_Fragment;

export type BulkUpdateContentSource_DisplayFragment = { __typename: 'Display', id: string, playlist?: { __typename: 'DisplayPlaylist', current?: { __typename: 'DisplayCurrentPlaylist', id: string, title: string } | null } | null, contentSource?: { __typename: 'ContentSourceSettings', available?: Array<{ __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null }> | null, current?: { __typename: 'ContentSourceState', reported: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null }, desired?: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } | null } | null, default?: { __typename: 'ContentSourceState', desired?: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } | null, reported: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } } | null } | null, bookmarks: { __typename: 'Bookmarks', all: { __typename: 'AllBookmarksState', reported?: Array<string> | null, desired?: Array<string | null> | null } } };

export const BulkUpdateContentSource_ContentSourceFragmentDoc = gql`
    fragment BulkUpdateContentSource_contentSource on ContentSource {
  ... on AppContentSource {
    label
    applicationId
  }
  ... on BookmarkContentSource {
    index
  }
  ... on InputContentSource {
    source
  }
  ... on PlaylistContentSource {
    playlistId
  }
}
    `;
export const BulkUpdateContentSource_DisplayFragmentDoc = gql`
    fragment BulkUpdateContentSource_display on Display {
  id
  ...UseContentSource_display
  playlist {
    current {
      id
      title
    }
  }
  contentSource {
    available {
      ...BulkUpdateContentSource_contentSource
    }
    current {
      reported {
        ...BulkUpdateContentSource_contentSource
      }
      desired {
        ...BulkUpdateContentSource_contentSource
      }
    }
  }
}
    ${UseContentSource_DisplayFragmentDoc}
${BulkUpdateContentSource_ContentSourceFragmentDoc}`;